import type { CreateMenuCategory } from '@/components/global/TopNavigation/components/CreateMenu/types';

export const createMenuItems: CreateMenuCategory[] = [
  {
    name: 'registration',
    label: 'CreateMenuCategoryRegistration',
    items: [
      {
        name: 'expense_personal',
        label: 'CreateMenuItemExpensePersonal',
        path: '/Registration/EmployeeExpense',
        requiredPermission: 'EmployeeExpense',
      },
      {
        name: 'mileage',
        label: 'CreateMenuItemMileage',
        path: '/Registration/Mileage/NewMileageRegistration',
        requiredPermission: 'MileageRegistration',
      },
      {
        name: 'import_personal_expenses',
        label: 'CreateMenuItemImportPersonalExpenses',
        path: '/Registration/Timesheet/ImportEmployeeExpenses',
        requiredPermission: 'ImportEmployeeExpenses',
      },
    ],
  },
  {
    name: 'project',
    label: 'CreateMenuCategoryProject',
    items: [
      {
        name: 'project',
        label: 'CreateMenuItemProject',
        path: '/ProjectManagement/Project/New',
        requiredPermission: 'NewProject',
      },
      {
        name: 'project_quick_create',
        label: 'CreateMenuItemProjectQuickCreate',
        path: '/ProjectManagement/Project/NewQuick',
        requiredPermission: 'NewQuickProject',
      },
      {
        name: 'project_expense',
        label: 'CreateMenuItemProjectExpense',
        path: '/ProjectManagement/ProjectExpense',
        requiredPermission: 'ProjectExpense',
      },
      {
        name: 'import_project_expenses',
        label: 'CreateMenuItemImportProjectExpenses',
        path: '/ProjectManagement/ProjectExpense/ImportProjectExpenses',
        requiredPermission: 'ImportProjectExpenses',
      },
    ],
  },
  {
    name: 'employees',
    label: 'CreateMenuCategoryEmployees',
    items: [
      {
        name: 'employees',
        label: 'CreateMenuItemEmployees',
        path: '/Organization/Employee/NewEmployee',
        requiredPermission: 'NewEmployee',
      },
    ],
  },
  {
    name: 'invoices',
    label: 'CreateMenuCategoryInvoices',
    items: [
      {
        name: 'invoice',
        label: 'CreateMenuItemInvoice',
        path: '/Financial/Invoicing/NewInvoice',
        requiredPermission: 'InvoiceNew',
      },
      {
        name: 'voucher',
        label: 'CreateMenuItemVoucher',
        path: '/Financial/Invoicing/NewVoucher',
        requiredPermission: 'VoucherNew',
      },
      {
        name: 'credit_note',
        label: 'CreateMenuItemCreditNote',
        path: 'Financial/Invoicing/NewCreditNote',
        requiredPermission: 'CreditNoteNew',
      },
    ],
  },
  {
    name: 'customers',
    label: 'CreateMenuCategoryCustomers',
    items: [
      {
        name: 'customer',
        label: 'CreateMenuItemCustomer',
        path: '/CRM/Customer/New',
        requiredPermission: 'NewCRMCustomer',
      },
      {
        name: 'contact',
        label: 'CreateMenuItemContact',
        path: '/CRM/Contact/New',
        requiredPermission: 'NewCRMContact',
      },
      {
        name: 'event',
        label: 'CreateMenuItemEvent',
        path: '/CRM/Event/New',
        requiredPermission: 'NewCRMEvent',
      },
      {
        name: 'opportunity',
        label: 'CreateMenuItemOpportunity',
        path: '/CRM/Opportunity/New',
        requiredPermission: 'NewCRMOpportunity',
      },
    ],
  },
];
